import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  list (URL, header, body, success, error) {
    Vue.axios.post(URL + 'calendar/v1/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listByDate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/calendar/date/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  new (URL, header, body, success, error) {
    Vue.axios.post(URL + 'calendar/v1/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_calendar.js